import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Componente che carica Smartsupp solo per utenti NON autenticati
 * (pagine pubbliche: login, registrazione, landing)
 */
const SmartsuppWidget = () => {
    const location = useLocation();

    useEffect(() => {
        // Pagine dove mostrare Smartsupp (NON autenticate)
        const publicPages = ['/', '/login', '/register'];
        const isPublicPage = publicPages.includes(location.pathname);
        
        // Controlla se l'utente è autenticato dal localStorage
        const authData = localStorage.getItem('auth');
        const isAuthenticated = authData ? JSON.parse(authData)?.accessToken : false;

        // Carica Smartsupp solo se siamo in una pagina pubblica E l'utente NON è loggato
        if (isPublicPage && !isAuthenticated) {
            // Verifica che lo script non sia già stato caricato
            if (!window.smartsupp && !document.getElementById('smartsupp-script')) {
                
                // Inizializza Smartsupp
                window._smartsupp = window._smartsupp || {};
                window._smartsupp.key = '2a0ed52a9fe0b93c071d14fe721ef90aacc50566';
                
                // Carica lo script
                const script = document.createElement('script');
                script.id = 'smartsupp-script';
                script.type = 'text/javascript';
                script.charset = 'utf-8';
                script.async = true;
                script.src = 'https://www.smartsuppchat.com/loader.js?';
                
                // Funzione di callback per gestire il caricamento
                window.smartsupp = function() {
                    window.smartsupp._.push(arguments);
                };
                window.smartsupp._ = [];
                
                // Inserisci lo script nel DOM
                const firstScript = document.getElementsByTagName('script')[0];
                firstScript.parentNode.insertBefore(script, firstScript);
            } else if (window.smartsupp && window.smartsupp.chat) {
                // Se esiste già, mostralo
                window.smartsupp.chat.show();
            }
        } else {
            // Se l'utente è loggato o non siamo in una pagina pubblica, nascondi Smartsupp
            if (window.smartsupp && window.smartsupp.chat) {
                window.smartsupp.chat.hide();
            }
        }

    }, [location.pathname]);

    return null; // Questo componente non renderizza nulla
};

export default SmartsuppWidget;
